<!-- product add button -->
<div class="qty-controller-comp">
  <div
    (click)="onDecrease()"
    [class.disabled-decrement-action]="value() <= 0"
    class="det-default-qty-action action-minus"
  >
    <span class="qty-action-minus"></span>
  </div>
  <span>
    <input
      class="det-default-qty-input disabled-input-action"
      type="text"
      (focusout)="changeQuantity(input.value)"
      [value]="value()"
      #input
    />
  </span>
  <div (click)="onIncrease()" class="det-default-qty-action action-plus">
    <span class="qty-action-plus"></span>
  </div>
</div>
